import { useEffect, useState } from "react";

// Devuelve `valor` recién después de que pasen `delayMs` sin que vuelva a cambiar.
export const useDebounced = (valor, delayMs) => {
  const [debounced, setDebounced] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(valor), delayMs);
    return () => clearTimeout(t);
  }, [valor, delayMs]);
  return debounced;
};
